<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" class="pa-0 pt-4">
        <v-form ref="form">
          <v-textarea
            :disabled="!isEditChecklist"
            v-model="description"
            v-bind="form.description.props"
          ></v-textarea>
        </v-form>
      </v-col>
      <v-col v-if="isEditChecklist" cols="12" class="pa-0">
        <v-container fluid class="pa-0">
          <v-row no-gutters class="justify-space-between">
            <v-col
              class="pa-1"
              cols="3"
              v-for="(image, index) in imagesCheck"
              :key="index"
            >
              <v-card text tile class="checklist__single-image" white>
                <v-container fluid fill-height class=" pa-0">
                  <v-row
                    no-gutters
                    column
                    class="text-center justify-space-between fill-height"
                  >
                    <template v-if="image.src" class="text-center">
                      <v-icon
                        v-if="isEditChecklist"
                        class="checklist__icon-delete"
                        color="accent"
                        dense
                        size="16"
                        @click.prevent="deleteAndCleanImage(index)"
                        >fas fa-plus</v-icon
                      >
                      <img
                        :src="validSrcImage(image.src)"
                        class="checklist__image"
                        alt="Image check"
                      />
                      <v-col
                        tag="div"
                        block
                        class="text-center checklist__image-text pa-0"
                        cols="12"
                        >{{ image.titleSection }}</v-col
                      >
                    </template>
                    <template v-else>
                      <v-icon
                        class="checklist__icon"
                        color="gray"
                        @click.prevent="uploadImage(index)"
                        @onUpload="startImageResize"
                        @onComplete="endImageResize"
                        >fas fa-plus</v-icon
                      >
                      <template slot="loading">
                        <v-progress-circular
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                      </template>
                      <v-col
                        tag="div"
                        block
                        class="text-center checklist__image-text pa-0"
                        cols="12"
                      >
                        {{ image.titleSection }}
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col v-else cols="12" class="pa-0">
        <v-carousel
          next-icon="keyboard_arrow_right"
          prev-icon="keyboard_arrow_left"
          hide-delimiters
          height="200px"
        >
          <v-carousel-item
            v-for="(image, index) in imagesCarousel"
            :key="index"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <a
              :href="validSrcImage(image.src)"
              target="_blank"
              v-if="image.src"
            >
              <v-img
                contain
                :src="validSrcImage(image.src)"
                height="200px"
              ></v-img>
            </a>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-row class="justify-end" v-show="isEditChecklist">
        <v-col cols="12" md="4" class="save-checklist__btn">
          <v-btn
            :disabled="!description.length || !imagesValid"
            class="black--text"
            block
            color="accent"
            @click.stop="saveCheckData()"
          >
            Guardar incidencia
          </v-btn>
        </v-col>
      </v-row>
    </v-row>
    <input
      v-show="false"
      ref="uploadcheck"
      :type="'file'"
      accept="image/jpeg,image/png"
      @change="resizeFileImage($refs.uploadcheck.files)"
    />
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import Checklist from "@/models/damage";
import { ResizeImage } from "@/services/ResizeImage";
export default {
  data() {
    return {
      form: Checklist.getChecklistForm(),
      description: "",
      imagesCheck: [
        { titleSection: "Tomar foto 1", src: null, id: 1 },
        { titleSection: "Tomar foto 2", src: null, id: 2 },
        { titleSection: "Tomar foto 3", src: null, id: 3 },
        { titleSection: "Tomar foto 4", src: null, id: 4 }
      ],
      imagesCarousel: [],
      currentImageIndex: ""
    };
  },
  async mounted() {
    if (!this.isEditChecklist) {
      this.imagesCheck = this.images;
      for (const image of this.imagesCheck) {
        if (image.src) this.imagesCarousel.push(image);
      }
      this.description = this.descriptionCheck;
    }
  },
  props: [
    "name",
    "title",
    "isEditChecklist",
    "indexCheck",
    "descriptionCheck",
    "images"
  ],
  computed: {
    imagesValid() {
      let result = false;
      for (const image of this.imagesCheck) {
        if (image.src) result = true;
      }
      return result;
    }
  },
  methods: {
    ...mapActions("checklist", ["saveChecklistInicidence"]),
    validSrcImage(url) {
      if (!this.isEditChecklist) {
        if (!url) return null;
        if (url.includes("https")) return url;
        return require("@/assets/logo.png");
      }
      return url;
    },
    uploadImage(id) {
      this.currentImageIndex = id;
      this.$refs.uploadcheck.click();
    },
    async resizeFileImage(refImage) {
      if (refImage) {
        const config = {
          file: refImage[0],
          maxSize: 1080
        };
        const resizedImage = await ResizeImage(config);
        this.imagesCheck[this.currentImageIndex].src = resizedImage;
        this.$refs.uploadcheck.value = null;
      }
    },
    async saveCheckData() {
      const checklistData = {
        checklistName: this.name,
        title: this.title,
        description: this.description,
        checked: true,
        incidence: true,
        images: this.imagesCheck,
        notApply: false
      };
      await this.saveChecklistInicidence(checklistData);
    },
    deleteAndCleanImage(id) {
      this.imagesCheck[id].src = null;
    },
    startImageResize() {
      loaderStart();
    },
    endImageResize() {
      loaderDone();
    }
  }
};
</script>
<style scoped>
.checklist {
  border: 1px solid lightgray;
}
.checklist__single-image {
  border: 1px solid lightgray;
  border-radius: 2px;
  height: 90px;
  max-width: 200px;
  margin: 0 auto;
}
.checklist__icon {
  padding: 1rem;
  margin: 0 auto;
}
.checklist__icon-delete {
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  right: 4px;
  top: 4px;
  transform: rotate(45deg);
  position: absolute;
}
.checklist__image {
  max-height: 103px;
  object-fit: contain;
  margin: 0;
  height: 80%;
  padding: 0 4px;
  width: 100%;
}
.checklist__image-text {
  background-color: gray;
  color: white;
  font-size: 12px;
  background-clip: content-box;
  max-height: 30px;
}
</style>
